<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <div>
    <div class="card">
      <validation-observer ref="simpleRules">
        <b-form>
          <div class="card-header">
          </div>
          <div class="card-body">
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Name</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Name"
                      rules="required"
                  >
                    <b-form-input
                        id="name"
                        v-model="createdProject.name"
                        name="name"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Budget</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Budget"
                      rules="required"
                  >
                    <b-form-input
                        id="name"
                        type="number"
                        v-model="createdProject.budget"
                        name="name"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="projectStatus">Status</label>
                  <validation-provider
                      #default="{ errors }"
                      name="project Status"
                      rules="required"
                  >

                    <v-select
                        id="projectStatus"
                        :class="errors.length > 0 ? 'error-border':null"
                        v-model="createdProject.projectStatus"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="projectAttributes.projectStatuses"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="country">Country</label>
                  <validation-provider
                      #default="{ errors }"
                      name="country"
                      rules="required"
                  >
                    <v-select
                        id="country"
                        v-model="createdProject.country"
                        :class="errors.length > 0 ? 'error-border':null"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="projectAttributes.countries"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="city">City</label>
                  <validation-provider
                      #default="{ errors }"
                      name="city"
                      rules="required"
                  >
                    <v-select
                        id="city"
                        v-model="createdProject.city"
                        :class="errors.length > 0 ? 'error-border':null"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="getCountryCities"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="type">Area</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Area"
                      rules="required"
                  >
                    <v-select
                        id="areas"
                        :class="errors.length > 0 ? 'error-border':null"
                        v-model="createdProject.area"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="getCityArea"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Project Reference</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Reference"
                      rules="required"
                  >
                    <b-form-input
                        id="name"
                        v-model="createdProject.projectReference"
                        name="projectReference"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="projectType">Type</label>
                  <validation-provider
                      #default="{ errors }"
                      name="project Type"
                      rules="required"
                  >

                    <v-select
                        id="projectType"
                        :class="errors.length > 0 ? 'error-border':null"
                        v-model="createdProject.projectType"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="projectAttributes.projectTypes"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="type">Client</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Client"
                      rules="required"
                  >
                    <v-select
                        id="client"
                        :class="errors.length > 0 ? 'error-border':null"
                        v-model="createdProject.userId"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="projectAttributes.clients"
                        :reduce="full_name => full_name.id"
                        label="full_name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="signingDate">Signing Date</label>
                  <validation-provider
                      #default="{ errors }"
                      name="signingDate"
                      rules="required"
                  >
                    <template>
                      <b-form-datepicker
                          id="signingDate"
                          v-model="createdProject.signingDate"
                          :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                          menu-class="w-100"
                          calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="initiatedDate">Initiated Date</label>
                  <validation-provider
                      #default="{ errors }"
                      name="initiatedDate"
                      rules="required"
                  >
                    <template>
                      <b-form-datepicker
                          id="initiatedDate"
                          v-model="createdProject.initiatedDate"
                          :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                          menu-class="w-100"
                          calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Longitude</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Longitude"
                      rules="required"
                  >
                    <b-form-input
                        id="name"
                        type="number"
                        v-model="createdProject.lon"
                        name="name"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Latitude</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Latitude"
                      rules="required"
                  >
                    <b-form-input
                        id="name"
                        type="number"
                        v-model="createdProject.lat"
                        name="Latitude"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="projectStatus">Currency</label>
                  <validation-provider
                      #default="{ errors }"
                      name="currency"
                      rules="required"
                  >

                    <v-select
                        id="currency"
                        :class="errors.length > 0 ? 'error-border':null"
                        v-model="createdProject.currency"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="[{name: 'AED', id: 'AED'}]"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Villa Number</label>
                  <validation-provider
                      #default="{ errors }"
                      name="villaNumber"
                      rules="required"
                  >
                    <b-form-input
                        id="villaNumber"
                        type="text"
                        v-model="createdProject.villaNumber"
                        name="villaNumber"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Plot Number</label>
                  <validation-provider
                      #default="{ errors }"
                      name="plotNumber"
                      rules="required"
                  >
                    <b-form-input
                        id="plotNumber"
                        type="text"
                        v-model="createdProject.plotNumber"
                        name="villaNumber"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Street Number</label>
                  <validation-provider
                      #default="{ errors }"
                      name="streetNumber"
                      rules="required"
                  >
                    <b-form-input
                        id="streetNumber"
                        type="text"
                        v-model="createdProject.streetNumber"
                        name="villaNumber"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Approved Layout From Consultant</label>
                  <validation-provider
                      #default="{ errors }"
                      name="approvedLayoutFromConsultant"
                      rules="required"
                  >
                    <b-form-file
                        v-model="createdProject.approvedLayoutFromConsultant"
                        :file-name-formatter="formatNames"
                        accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Title Deed</label>
                  <validation-provider
                      #default="{ errors }"
                      name="titleDeed"
                      rules="required"
                  >
                    <b-form-file
                        v-model="createdProject.titleDeed"
                        :file-name-formatter="formatNames"
                        accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label for="image">Initial Site Images</label>
                  <validation-provider
                      #default="{ errors }"
                      name="initialSiteImages"
                      rules=""
                  >
                    <vue-dropzone
                        id="image"
                        ref="createProjectRef"
                        name="image"
                        :options="dropzoneOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="card-footer" style="display: flex; justify-content: end;">
            <button
                type="button"
                class="btn btn-primary"
                @click.prevent="validationForm"
            >
              Submit
            </button>
          </div>
        </b-form>
      </validation-observer>
    </div>

  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import { required } from 'vee-validate/dist/rules';
import {BCol, BForm, BFormDatepicker, BFormFile, BFormGroup, BFormInput, BFormTextarea, BRow} from 'bootstrap-vue'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import projectService from '../../../services/projectService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      projectAttributes: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
      },
      createdProject: {
        userId: '',
        projectType: '',
        country: '',
        city: '',
        area: '',
        projectStatus: '',
        projectReference: '',
        name: '',
        budget: '',
        signingDate: '',
        initiatedDate: '',
        lat: '',
        lon: '',
        villaNumber: '',
        plotNumber: '',
        streetNumber: '',
        titleDeed: null,
        approvedLayoutFromConsultant: null,
        initialSiteImages: '',
        // hashCode: '',
        // contract: null,
        currency: ''
      }
    }
  },
  mounted() {
    this.getProjectAttribute()
  },
  computed: {
    getCountryCities() {
      this.createdProject.city = ''
      this.createdProject.area = ''
      return (this.projectAttributes.cities ?? []).filter(city => this.createdProject.country == city.country_id);
    },
    getCityArea() {
      this.createdProject.area = ''
      return (this.projectAttributes.areas ?? []).filter(area => this.createdProject.city == area.city_id);
    }
  },
  methods: {
    getProjectAttribute(withLoading = true) {
      projectService.attributes().then(response => {
        this.projectAttributes = response.data.data
        console.log(this.projectAttributes)
      })
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              this.createdProject.initialSiteImages = this.$refs.createProjectRef.getAcceptedFiles()
              projectService.post(this.createdProject)
                  .then(response => {
                    this.loading = false
                    if (response) {
                      this.$refs.createProjectRef.removeAllFiles()
                      $('#createModal').modal('hide')
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Project Is Created Successfully !`,
                        },
                      })
                      this.$router.push({name: 'projects'})
                    }
                  })
            }
          })
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}

.error-border {
  border: 1px solid #ea5455 !important;
}
</style>
